var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

import ViewModelUtil from 'gw-portals-viewmodel-js/ViewModelUtil';

/**
 * This class is a common parent to policy transactions wizard entry, this way we don't need replicate this logic
 * every time that we create a new entry for a policy transaction wizard.
 * A sample of how to implement the sub class in: "edge/gw-portals-renewal-angular/entry/RenewalEntryCtrl.js"
 */

var TransactionEntryCtrl = function () {
    function TransactionEntryCtrl($scope, wizardFlowService, StateUtils) {
        _classCallCheck(this, TransactionEntryCtrl);

        this.$scope = $scope;
        this.StateUtils = StateUtils;
        this.wizardFlowService = wizardFlowService;
    }

    _createClass(TransactionEntryCtrl, [{
        key: 'startWizardFlow',
        value: function startWizardFlow() {
            var _this = this;

            var parentWizardState = 'baseTransactionWizard';

            var getViewModelID = function getViewModelID(vm) {
                var model = ViewModelUtil.cleanse(vm);
                return model.jobID ? model.jobID : model.quoteID;
            };

            var stepToStateMapping = {
                returnHome: function returnHome(model) {
                    return _this.constructor.returnToDetailsPage(getViewModelID(model));
                },
                confirmation: function confirmation(model) {
                    return ['policyTransactionConfirmation', {
                        transactionSummary: ViewModelUtil.cleanse(model)
                    }];
                },
                transactionError: function transactionError(modelParam) {
                    return _this.constructor.returnToDetailsPage(getViewModelID(modelParam));
                }
            };

            var flowFactory = this.wizardFlowService(this.getCompositeFlow(), parentWizardState, stepToStateMapping);

            this.buildModel().then(function (_ref) {
                var model = _ref.model,
                    resume = _ref.resume;

                if (resume) {
                    _this.$scope.flow = flowFactory.resume(model);
                } else {
                    _this.$scope.flow = flowFactory.start(model);
                }
                _this.StateUtils.activeDataForState().flowModel = _this.$scope.flow;
            });
        }
    }]);

    return TransactionEntryCtrl;
}();

export default TransactionEntryCtrl;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gw-portals-policytransaction-common-angular/transactionEntry/TransactionEntryCtrl.js
// module id = 343
// module chunks = 0